export enum DialogType {
  Availability,
  CancelBooking,
  Checkout,
  ConfirmTrip,
  Editor,
  GooglePlacesImport,
  NewExperience,
}
